import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import { PDFTemplate } from "./PDFTemplate";

const PDF = ({ location }) => {
  const { state: { employeeDetails } = {} } = location;
  return (
    <Fragment>
      <Link
        className="py-5 my-5 ml-3 text-decoration-none"
        to="/ExitEmployeeList"
      >
        Back to Employee List
      </Link>
      <PDFViewer className="mt-3" width="100%" height="1000">
        <PDFTemplate
          employeeDetails={employeeDetails}
          pdfType="Leave Encashment"
          showBoth={true}
        />
      </PDFViewer>
    </Fragment>
  );
};
export default PDF;
